var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"smvp-sidebar-poll-voted"},[_c('span',{staticClass:"question"},[_vm._v(_vm._s(_vm.question))]),_vm._l((_vm.votes),function(vote,index){return _c('poll-answer',{key:index,attrs:{"text":vote.text,"selected":vote.selected}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }